{
  "id": 47,
  "location": "paris",
  "difficulty": "normal",
  "moves": 17,
  "kinds": 6,
  "goals": [
    { "type": "mud" },
    { "type": "collect", "kind": "cookie", "count": 28 }
  ],
  "stars": [3210, 4180],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    ". x . x . x . x",
    "x . x . x . x .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.729, "movesLeft": 4.2, "closeLosses": 0.118, "target": 0.68 }
}
